import { useMyContext } from "Context/MyContextProvider";
import React, { useEffect, useRef, useState } from "react";
import {
  faChevronDown,
  faChevronUp,
  faPhone,
  faReply,
  faUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Image, Row, Tooltip } from "antd";
import Flex from "components/shared-components/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { extractCarouselTemplateSections } from "../../Carousel/CarouselTemplates";
import { renderBody } from "../../Utils/utils";
import { useTemplates } from 'hooks/api';
const styles = {
  chatBackground: {},
  chatBubble: {
    background: "white",
    borderRadius: "8px",
    padding: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    position: "relative",
    wordWrap: "break-word",
  },
  buttoneBubble: {
    background: "white",
    borderRadius: "8px",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,

    // padding: '16px',
    boxShadow: "0 8px 8px -4px rgba(0, 0, 0, 0.15)",
    position: "relative",
    bottom: "0.5rem",
    wordWrap: "break-word",
  },
  chatBubbleBefore: {
    content: '""',
    position: "absolute",
    top: "0",
    right: "-5px", // Changed from left: "-5px" to right: "-5px"
    width: "0",
    height: "0",
    borderStyle: "solid",
    borderWidth: "10px 0 10px 10px", // Changed from "10px 10px 10px 0" to "10px 0 10px 10px"
    borderColor: "transparent transparent transparent white", // Changed from "transparent white transparent transparent"
    background: "#ffff",
    backgroundColor: "#ffff",
    clipPath: "polygon(0 0, 100% 0, 0 100%)", // Changed from "polygon(0 0, 0 100%, 100% 100%)"
    transform: "none", // Removed rotation since we're flipping the shape horizontally
  },
  chatTime: {
    textAlign: "right",
    fontSize: "12px",
    color: "gray",
    // marginTop: '4px',
  },
  footerMessageStyle: {
    fontSize: "12px",
    marginTop: "5px",
    color: "#918f8f",
  },
  buttonStyle: {
    // fontSize: '11px',
    wordWrap: "break-word",
    fontFamily: "system-ui",
    display: "block",
    textAlign: "justify",
  },
};
const RanderCarouselPreview = ({ presets, text }) => {
  const { getMedia } = useMyContext();
  const { templates } = useTemplates();
  const [mainBody, setMainBody] = useState(null);
  const [isLoop, setIsLoop] = useState(false);
  const [cards, setCards] = useState([]);
  const carouselRef = useRef(null);
  const [showCards, setShowCards] = useState(false);
  useEffect(() => {
    if (text) {
      const preset = presets?.find((item) => item?.name === text);
      let templateName = JSON.parse(preset?.object)?.template?.name;
      const template = templates?.find((item) => item?.name === templateName);
      //   console.log("template",template);
      if (template) {
        const { templateCards, mainBodyTemp } =
          extractCarouselTemplateSections(template);
        setMainBody(mainBodyTemp);
        setCards(templateCards);

        setTimeout(() => {
          setIsLoop(true);
        }, 500);
      }
    }
  }, [text]);
  const toggleCardsVisibility = () => {
    setShowCards((prev) => {
      // When turning on cards, start the carousel after a delay
      if (!prev) {
        setTimeout(() => {
          setIsLoop(true);
        }, 500);
      } else {
        // When hiding cards, stop carousel
        setIsLoop(false);
      }
      return !prev;
    });
  };
  const carouselStyle = {
    height: showCards ? (cards?.length > 0 ? "auto" : "0") : "0",
    minHeight: showCards ? (cards?.length > 0 ? "200px" : "0") : "0",
    opacity: showCards ? 1 : 0,
    overflow: "hidden",
    transition: "height 0.5s ease, opacity 0.5s ease, min-height 0.5s ease",
  };

  const additionalStyles = {
    showCardsButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "10px auto 5px",
      padding: "5px 15px",
      borderRadius: "16px",
      background: "white",
      border: "1px solid #e0e0e0",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      cursor: "pointer",
      color: "#00a5f4",
      fontWeight: "bold",
    },
  };
  const enhancedStyles = {
    ...styles,
    cardContainer: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    chatBubbleFixed: {
      ...styles.chatBubble,
      flex: 1,
      display: "flex",
      flexDirection: "column",
      minHeight: "200px", // Ensure minimum height for all cards
    },
    buttonText: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "85%", // Limit button text width
    },
    buttoneBubbleFixed: {
      ...styles.buttoneBubble,
      marginTop: "auto", // Push button area to bottom of card
    },
  };
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200 chat-preview-container" style={{ maxWidth: '20rem', width: '100%' }}>
      <div style={styles.chatBackground}>
        <div style={styles.chatBubble}>
          <div style={styles.chatBubbleBefore} />
          {mainBody?.text && renderBody(mainBody?.text)}
        </div>
        {/* Only show the toggle button if there are cards */}
        {cards && cards?.length > 0 && (
          <div style={carouselStyle}>
            <Row>
              {cards?.map((item, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                  <div key={index} className="mt-1">
                    <div style={styles.chatBubble}>
                      <Flex flexDirection="column" gap="8px">
                        {item?.header?.format === "DOCUMENT" ? (
                          <div
                            className="border rounded d-flex justify-content-center align-items-center mb-3"
                            style={{ background: "#ccd0d5" }}
                          >
                            <img
                              src={"/img/pdfBackground.png"}
                              className="my-3"
                              width={70}
                              alt="pdf"
                            />
                          </div>
                        ) : item?.header?.format === "IMAGE" ? (
                          <>
                            <Image
                              width={"100%"}
                              height={100}
                              src={"/img/others/dummy-header.jpg"}
                              className="mt-1 rounded"
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                              preview={false}
                            />
                          </>
                        ) : item?.header && item?.header?.format === "VIDEO" ? (
                          <div
                            className=" d-flex justify-content-center align-items-center mb-3"
                            style={{ background: "" }}
                          >
                            <img
                              src={"/img/dummyvideo.png"}
                              className="mt-1 border rounded"
                              alt="video"
                              width={"100%"}
                            />
                          </div>
                        ) : (
                          <div className="header">
                            <h5>{item?.header?.text}</h5>
                          </div>
                        )}
                        {renderBody(item?.body?.text)}
                      </Flex>
                      <span className="text-gray-light h6">
                        Card {index + 1}
                      </span>
                    </div>
                    {/* Buttons section with ellipsis and tooltips */}
                    <div style={enhancedStyles.buttoneBubbleFixed}>
                      {item?.buttons?.buttons?.length > 0 &&
                        item?.buttons?.buttons?.map(
                          (buttonItem, buttonIndex) => {
                            // Display the first 2 QUICK_REPLY buttons and all other buttons
                            if (
                              buttonItem?.type === "QUICK_REPLY" &&
                              buttonIndex < 2
                            ) {
                              return (
                                <Tooltip
                                  key={buttonIndex}
                                  title={buttonItem?.text}
                                  placement="bottom"
                                >
                                  <span
                                    style={styles.buttonStyle}
                                    className="border-top py-2"
                                  >
                                    <button
                                      className="border-0 bg-transparent w-100"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#00a5f4",
                                      }}
                                    >
                                      <Flex
                                        justifyContent="center"
                                        alignItems="center"
                                        gap="5px"
                                      >
                                        <FontAwesomeIcon icon={faReply} />
                                        <span style={enhancedStyles.buttonText}>
                                          {buttonItem?.text}
                                        </span>
                                      </Flex>
                                    </button>
                                  </span>
                                </Tooltip>
                              );
                            } else if (buttonItem?.type !== "QUICK_REPLY") {
                              return (
                                <Tooltip
                                  key={buttonIndex}
                                  title={buttonItem?.text}
                                  placement="bottom"
                                >
                                  <span
                                    style={styles.buttonStyle}
                                    className="border-top py-2"
                                  >
                                    <button
                                      className="border-0 bg-transparent w-100"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#00a5f4",
                                      }}
                                    >
                                      <Flex
                                        justifyContent="center"
                                        alignItems="center"
                                        gap="5px"
                                      >
                                        {buttonItem?.type === "URL" && (
                                          <FontAwesomeIcon
                                            icon={faUpRightFromSquare}
                                          />
                                        )}
                                        {buttonItem?.type ===
                                          "PHONE_NUMBER" && (
                                            <FontAwesomeIcon icon={faPhone} />
                                          )}
                                        <span style={enhancedStyles.buttonText}>
                                          {buttonItem?.text}
                                        </span>
                                      </Flex>
                                    </button>
                                  </span>
                                </Tooltip>
                              );
                            }
                            return null;
                          }
                        )}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
        {cards?.length > 0 && (
          <button
            onClick={toggleCardsVisibility}
            style={additionalStyles.showCardsButton}
            className="mt-2 mb-1"
          >
            <Flex justifyContent="center" alignItems="center" gap="5px">
              <FontAwesomeIcon icon={showCards ? faChevronUp : faChevronDown} />
              <span>{showCards ? "Hide cards" : "View cards"}</span>
            </Flex>
          </button>
        )}
      </div>
    </div>
  );
};

export default RanderCarouselPreview;
